var MDB = window.MDB || {};
MDB.UI = MDB.UI || {};
MDB.UI.Loader = MDB.UI.Loader || {};

(function(){
    $.extend(MDB.UI.Loader, {
        show: function(){
            $('body')
                .addClass('mdb-loader-open')
                .append(
                    '<div class="mdb-loader-component modal-backdrop show"></div>' +
                    '<div class="mdb-loader-component download-loader"></div>'
                );
        },
        hide: function(){
            $('body')
                .removeClass('mdb-loader-open')
                .find('.mdb-loader-component')
                .remove();
        },
        showProgressCursor: function(){
            $('body')
                .addClass('cursor-progress');
        },
        stopProgressCursor: function(){
            $('body')
                .removeClass('cursor-progress');    
        }
    });
}());